// Grid Toggle Script
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var grid = document.getElementById('ProductGrid');
    if (!grid) return;
    var defaultColumns = grid.getAttribute('data-default-columns');
    var alternateColumns = grid.getAttribute('data-alternate-columns');
    var buttons = document.querySelectorAll('.grid-toggle__btn');
    var localKey = 'pd-grid-mode';

    function setGridMode(mode) {
      grid.setAttribute('data-grid-mode', mode);
      // Remove any card-grid--X class (X = 1-12)
      grid.className = grid.className.replace(/\bcard-grid--\d+\b/g, '').replace(/\s+/g, ' ').trim();
      // Add the correct grid class
      var col = mode === 'alternate' ? alternateColumns : defaultColumns;
      grid.classList.add('card-grid--' + col);
      buttons.forEach(function(btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-grid-mode') === mode ? 'true' : 'false');
      });
      localStorage.setItem(localKey, mode);
    }

    // Initial mode
    var initialMode = localStorage.getItem(localKey) || 'default';
    setGridMode(initialMode);

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setGridMode(btn.getAttribute('data-grid-mode'));
      });
    });
  });
})(); 